/* istanbul ignore file */
import {
  CLEAR_SELECTED_INSIGHT,
  ON_CLICK_INSIGHT,
  ON_COMPONENT_LOADING
} from './actions';
import { PROJECT_PROGRESSION_COMPONENTS } from './components';

export const generateInitialState = () => {
  return {
    selectedInsightKey: null,
    loadingMap: {
      [PROJECT_PROGRESSION_COMPONENTS.PROGRESSION_OVER_TIME]: true,
      [PROJECT_PROGRESSION_COMPONENTS.INSIGHTS]: true,
      [PROJECT_PROGRESSION_COMPONENTS.PROGRESSION_TABLE]: true
    }
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    case CLEAR_SELECTED_INSIGHT:
      return {
        ...state,
        selectedInsightKey: null
      };

    case ON_CLICK_INSIGHT:
      const isInsightSelected = state.selectedInsightKey === action.payload;
      return {
        ...state,
        selectedInsightKey: isInsightSelected ? null : action.payload
      };

    case ON_COMPONENT_LOADING:
      return {
        ...state,
        loadingMap: {
          ...state.loadingMap,
          [action.payload.compKey]: action.payload.isLoading
        }
      };

    default:
      return state;
  }
};

export default reducer;
